import type { PayloadAction } from '@reduxjs/toolkit';
import { createSlice } from '@reduxjs/toolkit';

interface AccountManagementState {
  blockDuration?: string;
  maxRequestCount?: number;
  requisiteId?: number | null;
  blockedTime?: string | null;
  blockedGroupId?: string | number | null;
  isShowTimerReceiveCode?: boolean;
}

const initialState: AccountManagementState = {
  blockDuration: '',
  maxRequestCount: 0,
  requisiteId: null,
  isShowTimerReceiveCode: false,
};

const accountManagementSlice = createSlice({
  name: 'accountManagement',
  initialState,
  reducers: {
    setSendCodeInfo: (state, action: PayloadAction<AccountManagementState>) => ({
      ...state,
      ...action.payload,
    }),
    setRequisiteId: (state, action: PayloadAction<number | null>) => ({
      ...state,
      requisiteId: action.payload,
    }),
    setShowTimerReceiveCode: (state, action: PayloadAction<boolean>) => ({
      ...state,
      isShowTimerReceiveCode: action.payload,
    }),
  },
});

export const maxRequestCountSelector = ({ accountManagement }: { accountManagement: AccountManagementState }) =>
  accountManagement.maxRequestCount;

export const requisiteIdSelector = ({ accountManagement }: { accountManagement: AccountManagementState }) =>
  accountManagement.requisiteId;

export const isShowTimerReceiveCodeSelector = ({ accountManagement }: { accountManagement: AccountManagementState }) =>
  accountManagement.isShowTimerReceiveCode;

export const { setSendCodeInfo, setRequisiteId, setShowTimerReceiveCode } = accountManagementSlice.actions;

export default accountManagementSlice.reducer;
